import React from "react";
import { Box, VStack, Text, Button, Spinner, Icon } from "@chakra-ui/react";
import { CheckCircleIcon } from "@chakra-ui/icons";
import { useNavigate, useSearchParams } from "react-router-dom";
import { fetchWithAuth } from "../utils/fetchWithAuth";

const SubscriptionSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = React.useState("loading"); // loading | success | error

  React.useEffect(() => {
    const sessionId = searchParams.get("session_id");
    if (!sessionId) {
      setStatus("error");
      return;
    }

    fetchWithAuth(`/api/subscription/checkout-success?session_id=${sessionId}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setStatus("success");
          // Auto-redirect after 4 seconds
          setTimeout(() => navigate("/billing"), 4000);
        } else {
          setStatus("error");
        }
      })
      .catch(() => setStatus("error"));
  }, [searchParams, navigate]);

  return (
    <Box minH="100vh" display="flex" alignItems="center" justifyContent="center" bg="gray.50">
      <VStack spacing={6} textAlign="center" maxW="sm" px={6}>
        {status === "loading" && (
          <>
            <Spinner size="xl" color="brand.600" thickness="4px" />
            <Text fontSize="lg" color="gray.600">Confirming your payment...</Text>
          </>
        )}

        {status === "success" && (
          <>
            <Icon as={CheckCircleIcon} boxSize={16} color="green.500" />
            <VStack spacing={2}>
              <Text fontSize="2xl" fontWeight="bold" color="gray.900">
                You're on Pabs Pro!
              </Text>
              <Text fontSize="md" color="gray.500">
                Your account has been upgraded. Enjoy unlimited access.
              </Text>
            </VStack>
            <Button
              bg="brand.700"
              color="white"
              size="lg"
              borderRadius="lg"
              _hover={{ bg: "brand.800" }}
              onClick={() => navigate("/billing")}
            >
              Go to my account
            </Button>
            <Text fontSize="xs" color="gray.400">Redirecting automatically in a moment...</Text>
          </>
        )}

        {status === "error" && (
          <>
            <VStack spacing={2}>
              <Text fontSize="2xl" fontWeight="bold" color="gray.900">
                Something went wrong
              </Text>
              <Text fontSize="md" color="gray.500">
                Your payment may have been processed. Check your plan status below.
              </Text>
            </VStack>
            <Button
              bg="brand.700"
              color="white"
              size="lg"
              borderRadius="lg"
              _hover={{ bg: "brand.800" }}
              onClick={() => navigate("/billing")}
            >
              Check my plan
            </Button>
          </>
        )}
      </VStack>
    </Box>
  );
};

export default SubscriptionSuccess;
